import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Input, Button, Form, message } from 'antd';
import { MaskedInput } from 'antd-mask-input';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import api from '../../app/api';
import { useTranslation } from '../../shared/hooks/useTranslation';
import style from './AdminLogin.module.scss';

interface LoginForm {
  phone: string;
  password: string;
}

export function AdminLogin() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onFinish = async (values: LoginForm) => {
    setLoading(true);
    try {
      const response = await api.post('/admin/login', values);

      if (response.status === 200) {
        const data = response.data;
        localStorage.setItem('adminToken', data.token);
        localStorage.setItem('adminUser', JSON.stringify(data.user));
        message.success(t.adminLoginSuccess);
        navigate('/admin/dashboard');
      } else {
        message.error(response.data?.error || t.adminLoginErrorGeneric);
      }
    } catch (error: any) {
      message.error(error.response?.data?.error || t.adminLoginErrorServer);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={style.container}>
      <div className={style.loginCard}>
        <div className={style.header}>
          <h1>{t.adminLoginTitle}</h1>
          <p>{t.adminLoginSubtitle}</p>
        </div>

        <Form
          name="admin_login"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
          className={style.form}
        >
          <Form.Item
            name="phone"
            rules={[
              { required: true, message: t.adminLoginPhoneRequired },
              { pattern: /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/, message: t.adminLoginPhoneInvalid }
            ]}
          >
            <MaskedInput
              prefix={<UserOutlined />}
              mask="+0 (000) 000-00-00"
              placeholder={t.adminLoginPhonePlaceholder}
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: t.adminLoginPasswordRequired }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder={t.adminLoginPassword}
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              size="large"
              loading={loading}
              className={style.loginButton}
              block
            >
              {t.adminLoginSubmit}
            </Button>
          </Form.Item>
        </Form>

        <div className={style.footer}>
          <p>{t.adminLoginFooter}</p>
        </div>
      </div>
    </div>
  );
}
